<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @open-detail="openDetail"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="skuInvOutOfStockList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
    </PageMain>

    <DetailDrawer
      :visible.sync="detailOpts.visible"
      :amzListingSkuOutOfStockCode="detailOpts.amzListingSkuOutOfStockCode"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header'
import PageMain from './main.vue'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
import DetailDrawer from '../detail-drawer'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, SortFieldsPopover, DetailDrawer },
  data() {
    return {
      usePage: true,
      sortFields: [],
      detailOpts: { visible: false, amzListingSkuOutOfStockCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzListingSkuOutofstockListApi({
          ...form,
          ...this.page,
          sortFields: this.sortFields,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetail({ amzListingSkuOutOfStockCode }) {
      this.detailOpts = { visible: true, amzListingSkuOutOfStockCode }
    },
  },
}
</script>
